import React, { createContext, useContext, useState, useEffect } from 'react';
import { verifyAdmin, logoutAdmin } from '../lib/api';

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  // null = checking, true = authenticated, false = not authenticated
  const [isAuthenticated, setIsAuthenticated] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('lavaporcar_admin_token');
      if (!token) {
        setIsAuthenticated(false);
        return;
      }
      try {
        await verifyAdmin();
        setIsAuthenticated(true);
      } catch (error) {
        logoutAdmin();
        setIsAuthenticated(false);
      }
    };
    checkAuth();
  }, []);

  const login = () => setIsAuthenticated(true);
  const logout = () => {
    logoutAdmin();
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
